import { FC } from 'react';
import type { ComecoDeMes } from '@/utils/filtroPaineis';
import { fmtData } from '@/utils/painelFormat';

const textoDias = (n: number): string => (n === 0 ? 'nenhum dia com dado ainda' : n === 1 ? 'só 1 dia com dado' : `só ${n} dias com dado`);

/**
 * Começo de mês (27/10/2026): o padrão das abas de produção é o mês atual, que nos primeiros dias
 * abre quase vazio — o mês de produção vira no dia 16 e a OP é reportada com 2 a 3 dias de atraso.
 * O aviso diz isso e leva ao mês anterior num clique.
 */
const AvisoComecoDeMes: FC<{ comeco: ComecoDeMes; onMesAnterior: () => void }> = ({ comeco, onMesAnterior }) => (
  <div
    role="status"
    data-testid="filtros-comeco-de-mes"
    className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-theme-border bg-surface-hover px-3 py-2 text-xs text-content-secondary"
  >
    <span className="flex items-start gap-1.5">
      <span aria-hidden className="material-symbols-outlined text-[16px] leading-none text-content-muted">
        event_upcoming
      </span>
      <span>
        {comeco.calendario === 'civil' ? 'O mês' : 'O mês de produção'} começou em {fmtData(comeco.inicio)} e tem{' '}
        {textoDias(comeco.dias)}. A OP é reportada com 2 a 3 dias de atraso: os números ainda vão crescer.
      </span>
    </span>
    <button
      type="button"
      onClick={onMesAnterior}
      data-testid="filtros-ver-mes-anterior"
      className="print-hide inline-flex items-center gap-1 rounded-lg border border-theme-border bg-surface-card px-2.5 py-1 font-medium text-content-primary hover:bg-surface-hover"
    >
      <span aria-hidden className="material-symbols-outlined text-[16px] leading-none">
        history
      </span>
      Ver o mês anterior
    </button>
  </div>
);

export default AvisoComecoDeMes;
